import styled from "styled-components";

export const Form = styled.form`
  width: 92.5%;
  max-width: 400px;

  display: flex;
  align-items: center;
  flex-direction: column;

  gap: 20px;
  margin: 0 auto 20px;
  padding: 34px 18px;

  border-radius: 3px;

  background-color: var(--grey-3);
  color: var(--grey-0);

  h2 {
    font-size: 18px;
    font-weight: 700;
  }

  div {
    width: 100%;

    display: flex;
    flex-direction: column;

    gap: 15px;
  }

  label {
    font-size: 12px;
    font-weight: 400;
  }

  p {
    font-size: 12px;
    font-weight: 400;

    padding-top: 8px;

    color: var(--grey-1);
  }

  input,
  select {
    font-size: 16px;
    font-weight: 400;

    padding: 8px 10px;

    border-radius: 4px;

    background-color: var(--grey-2);
    color: var(--grey-0);
  }

  .inputPassword {
    position: relative;

    .showPassword {
      position: absolute;
      top: 8px;
      left: 89.5%;
      
      font-size: 20px;

      color: var(--grey-1);
      background-color: transparent;
    }
  }
`;

export const FormTech = styled.form`
  width: 92.5%;
  max-width: 350px;

  display: flex;
  align-items: center;
  flex-direction: column;

  gap: 20px;
  margin: 0 auto 20px;

  border-radius: 5px;

  background-color: var(--grey-3);
  color: var(--grey-0);

  header {
    width: 100%;

    display: flex;
    justify-content: space-between;

    padding: 12px 18px;

    border-radius: 5px 5px 0 0;

    background-color: var(--grey-2);

    h3 {
      font-size: 13px;
      font-weight: 700;
    }

    button {
      background-color: transparent;
      color: var(--grey-1);

      &:hover {
        color: var(--grey-0);
      }
    }
  }

  div {
    width: 100%;

    display: flex;
    flex-direction: column;

    padding: 0px 18px 25px;
    gap: 19px;

    .infosInput {
      width: 100%;

      display: flex;
      flex-direction: column;

      padding: 0;
      gap: 15px;

      label {
        font-size: 12px;
        font-weight: 400;
      }

      p {
        font-size: 12px;
        font-weight: 400;

        padding-top: 8px;

        color: var(--grey-1);
      }

      input,
      select {
        font-size: 16px;
        font-weight: 400;

        padding: 8px 10px;

        border-radius: 4px;

        background-color: var(--grey-2);
        color: var(--grey-0);
      }
    }
  }
`;
